import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { AventuraService } from 'src/app/services/api/aventura.service';
import { FileService } from 'src/app/services/api/file.service';
import Swal from 'sweetalert2';
import { DialogAsignarEquiposComponent } from '../../asignacion-equipos/dialog-asignar-equipos/dialog-asignar-equipos.component';

@Component({
  selector: 'app-dialog-asignar-producto',
  templateUrl: './dialog-asignar-producto.component.html',
  styleUrls: ['./dialog-asignar-producto.component.css']
})
export class DialogAsignarProductoComponent implements OnInit {

  loading:boolean=true;

  dataSource = new MatTableDataSource();

  articulos:any;

  displayedColumns: string[] = [
    'Check',
    'nombre',
    'categoria',
    'tipo'

  ];

  file:any

  @ViewChild(MatPaginator) set paginator(value: MatPaginator) {
    this.dataSource.paginator = value;
  }

  //@ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(private fileService: FileService,private aventuraService: AventuraService,@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<DialogAsignarEquiposComponent>) { }

  ngOnInit(): void {
    console.log(this.data)
    this.getAllProducts()
  }

  getAllProducts() {
    this.aventuraService.getAllProducts().subscribe((response:any) => {
      this.articulos = response.getAllProducts;

      console.log(this.articulos)

      this.data.data.productos?.map((el:any)=>{
        this.articulos.map((art:any,index:any)=>{
          if(el.id===art.id){
            art.checked = true
            let removedItems=this.articulos.splice(index,1)
            this.articulos.unshift(...removedItems)
          }

        })
      })

      this.dataSource.data=this.articulos
      this.dataSource.paginator=this.paginator

      this.loading=false

    });

  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.articulos.map((fila: any) => {
        fila.checked = false;
      });
      return;
    } else {
      this.articulos.map((fila: any) => {
        fila.checked = true;
      });
      return;
    }
  }

  isAllSelected() {
    let lst: any[];
    lst = this.articulos.filter((x: any) => x.checked == true);
    const numSelected = lst.length;
    const numRows = this.articulos.length;
    return numSelected === numRows;
  }

  updateCheck(row: any) {
    console.log(row)
    row.checked = !row.checked;

  }

  async closeDialog() {

    const checked=this.dataSource.data.filter((el:any)=>el.checked)

        // Determinar los agregados
        const added = checked.filter((newItem:any) => !this.data.data.productos?.some((old:any) => old.id === newItem.id));

        // Determinar los eliminados
        const deleted = this.data.data.productos?.filter((old:any) => !checked.some((newItem:any) => newItem.id === old.id));
    
    //new elements


    await Promise.all(
      added.map(async (el:any)=>{
        await this.aventuraService.addProductAgrupadoWarehouse(el.id,this.data.data.id).toPromise()
        this.data.data.productos.push({id:el.id})
      })
    )

    //deleted elements

    await Promise.all(
      deleted.map(async (el:any)=>{
        await this.aventuraService.deleteProductAgrupadoWarehouse(el.id,this.data.data.id).toPromise()

        const indexToDelete=this.data.data.productos.findIndex((prod:any)=>prod.id===el.id)
        this.data.data.productos.splice(indexToDelete,1)
      })
    )

    Swal.fire({
      position: 'top-end',
      title: 'Los productos fueron asignados correctamente',
      icon:"success",
      showConfirmButton: false,
      timer: 5000
    }
  )
  this.dialogRef.close();


/*     console.log(equipos)
    console.log(this.data)

    equipos.map((el:any)=>{
      delete el.checked
      delete el.factura
      delete el.codigo
      delete el.fileAsignado
    })
    console.log(equipos)

    this.aventuraService.updateFileEquipos(this.file.id,equipos).subscribe((data:any)=>{
      console.log("updatedEquipoDone");
      console.log(data)
      Swal.fire({
          position: 'top-end',
          title: 'Los equipos se asignaron satisfactoriamente',
          icon:"success",
          showConfirmButton: false,
          timer: 5000
        }
      )
      this.dialogRef.close(equipos);
    }) */


  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }


}
